import React from "react";
export const useEventStopPropCallback = () => {
  const eventStopPropCallback = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => event.stopPropagation(),
    []
  );

  return eventStopPropCallback;
};
